import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function bovenLokaliteitPerDossierReducer(state = initialState.bovenLokaliteitPerDossier, action) {
	switch (action.type) {
		case types.BOVEN_LOKALITEIT_PER_DOSSIER_LOADED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors
				});
		}

		case types.BOVEN_LOKALITEIT_PER_DOSSIER_SAVED: {
			return Object.assign({},
				state,
				{
					item: action.body.item,
					errors: action.body.errors
				});
		}

		default:
			return state;
	}
}
